import { useMemo } from "react";
import {
  AUTH_EVENTS,
  authErrorDetails,
  getCurrentStudentId,
  logAuthEvent,
  logAuthEventBeforeLeaving,
} from "../utils/authEventLog";

/**
 * Sign-up / sign-in / logout logging for components (see utils/authEventLog).
 *
 *   const { logAuthEvent, AUTH_EVENTS } = useAuthEventLog();
 *   logAuthEvent(AUTH_EVENTS.OTP_RESENT, { status: "success", channel: "email" });
 *
 * logAuthEventBeforeLeaving is for a log sent right before a redirect (logout):
 * it goes out with keepalive, so navigate right after the call.
 */
const useAuthEventLog = () =>
  useMemo(
    () => ({
      logAuthEvent,
      logAuthEventBeforeLeaving,
      authErrorDetails,
      getCurrentStudentId,
      AUTH_EVENTS,
    }),
    [],
  );

export default useAuthEventLog;
